import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isChinese: false,
  showPrint: false,
  isVersionTwoEnabled: false,
  openDrawer: false,
  currentKpi: undefined,
  actisData: {},
  kpiData: [],
  minimalBenchmarkData: {},
  benchmarkForKpiData: {},
  lastUpdatedDate: undefined,
};

export const cyberSlice = createSlice({
  name: 'cyber',
  initialState,
  reducers: {
    setIsChinese: (state, action) => ({
      ...state,
      isChinese: action.payload,
    }),
    setShowPrint: (state, action) => ({
      ...state,
      showPrint: action.payload,
    }),
    setIsVersionTwoEnabled: (state, action) => ({
      ...state,
      isVersionTwoEnabled: action.payload,
    }),
    setActisData: (state, action) => ({
      ...state,
      actisData: action.payload,
    }),
    setOpenDrawer: (state, action) => ({
      ...state,
      openDrawer: action.payload,
    }),
    setCurrentKpi: (state, action) => ({
      ...state,
      currentKpi: action.payload,
    }),
    setKpiData: (state, action) => ({
      ...state,
      kpiData: action.payload,
    }),
    setMinimalBenchmarkData: (state, action) => ({
      ...state,
      minimalBenchmarkData: action.payload,
    }),
    setCurrentRR: (state, action) => ({
      ...state,
      currentRR: action.payload,
    }),
    setBenchmarkForKpiData: (state, action) => {
      const allDates = Object.values(action.payload)
        ?.map((item) => item?.lastUpdatedDate)
        ?.filter(Boolean);
      const exitsingDates = allDates.filter((val) => val !== undefined);
      const lastUpdatedDate = exitsingDates.length > 0 ? Math.max(...allDates) : undefined;
      const updatedByVal = Object.values(action.payload)
        ?.filter(Boolean)
        ?.filter((item) => item.lastUpdatedDate === lastUpdatedDate);
      const lastModifiedBy = updatedByVal[0]?.lastUpdatedBy;
      return {
        ...state,
        benchmarkForKpiData: action.payload,
        lastUpdatedDate,
        lastModifiedBy,
      };
    },
  },
});

export const {
  setIsChinese,
  setShowPrint,
  setIsVersionTwoEnabled,
  setActisData,
  setCurrentKpi,
  setOpenDrawer,
  setKpiData,
  setMinimalBenchmarkData,
  setBenchmarkForKpiData,
  setCurrentRR,
} = cyberSlice.actions;

export default cyberSlice.reducer;
